import * as basicScroll from 'basicscroll';

export const scrollCreateAndStart = ({
    elem,
    from = 'top-bottom',
    to = 'bottom-top',
    props,
    direct = true,
    inside,
    outside,
}: Partial<basicScroll.Data>) => {
    if (!elem) return;
    const created = basicScroll.create({
        elem,
        from,
        to,
        direct,
        props,
        inside,
        outside,
    });
    created.start();
};
